module.exports = __webpack_public_path__ + "static/Moody2-f0a912e4bee4d736712aa20b988dc9d2.png";